export type AttachmentAddBlockReason =
  | "loading"
  | "plan_attachment_count_reached"
  | "platform_storage_reached"
  | null;

type AttachmentAddEligibilityInput = {
  attachmentsAllowed?: number | null;
  currentAttachmentCount?: number | null;
  maxStorageBytesPerUser?: number | null;
  storageUsedBytes?: number | null;
  isPlanLoading?: boolean;
  isEffectivePlatformLimitsLoading?: boolean;
};

type AttachmentAddEligibilityResult = {
  canAddAttachment: boolean;
  reason: AttachmentAddBlockReason;
};

export function getAttachmentAddEligibility({
  attachmentsAllowed,
  currentAttachmentCount = 0,
  maxStorageBytesPerUser,
  storageUsedBytes = 0,
  isPlanLoading = false,
  isEffectivePlatformLimitsLoading = false,
}: AttachmentAddEligibilityInput): AttachmentAddEligibilityResult {
  const normalizedAttachmentCount = Number(currentAttachmentCount ?? 0);
  const normalizedStorageUsedBytes = Number(storageUsedBytes ?? 0);

  if (isPlanLoading || isEffectivePlatformLimitsLoading) {
    return {
      canAddAttachment: false,
      reason: "loading",
    };
  }

  if (
    typeof attachmentsAllowed === "number" &&
    Number.isFinite(attachmentsAllowed) &&
    normalizedAttachmentCount >= attachmentsAllowed
  ) {
    return {
      canAddAttachment: false,
      reason: "plan_attachment_count_reached",
    };
  }

  if (
    typeof maxStorageBytesPerUser === "number" &&
    Number.isFinite(maxStorageBytesPerUser) &&
    normalizedStorageUsedBytes >= maxStorageBytesPerUser
  ) {
    return {
      canAddAttachment: false,
      reason: "platform_storage_reached",
    };
  }

  return {
    canAddAttachment: true,
    reason: null,
  };
}
